import styled from 'styled-components'
import {
  Box,
  Text,
  SkeletonLoader,
} from '@usap/uicomponents'

export const Container = styled(Box)`
  flex-direction: column;
  align-items: start;
  background: ${props => props.theme.global.colors['light-1']};
  padding: 16px 8px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    flex-direction: row;
    align-items: center;
    background:  white;
    padding-left: ${props => props.theme.global.edgeSize.small};
    padding-bottom: 6px;
  }
`

export const TextContainer = styled(Box)`
  padding-bottom: ${props => props.theme.global.edgeSize.medium};
  border: none;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    border-right: solid 1px ${props => props.theme.global.colors['light-3']};
    padding-right: ${props => props.theme.global.edgeSize.medium};
    padding-bottom: 0px;
  }
`

export const VehicleTitle = styled(Text)`
  font-size: 20px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    font-size: 28px;
  }
`

export const ChangeVehicle = styled(Box)`
  padding: 0px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    padding-left: ${props => props.theme.global.edgeSize.medium};
  }
`

export const BrowseContainer = styled(Box)`
  padding-left: ${props => props.theme.global.edgeSize.medium};
`

export const SelectedVehicleTitlePlaceholder = styled(SkeletonLoader)`
  height: 24px;
  min-width: 200px;
`

export default {
  Container,
  TextContainer,
  VehicleTitle,
  ChangeVehicle,
  BrowseContainer,
  SelectedVehicleTitlePlaceholder,
}
